(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  class Limit {
    /**
     * Initializes a new instance of the class with default min and max values set to 0.
     *
     * @constructor
     */
    constructor() {
      this.min = 0;
      this.max = 0;
    }

    /**
     * Initializes the carousel limits with the specified minimum and maximum values.
     *
     * @param {number} min - The minimum value for the carousel.
     * @param {number} max - The maximum value for the carousel.
     */
    initialize(min, max) {
      this.min = min;
      this.max = max;
      this.length = Math.abs(min - max);
      return this;
    }

    /**
     * Determines if the given number is less than the minimum allowed value.
     *
     * @param {number} number - The number to check against the minimum value.
     * @returns {boolean} True if the number is less than the minimum; otherwise, false.
     */
    reachedMin(number) {
      return number < this.min;
    }

    /**
     * Determines if the given number exceeds the maximum allowed value.
     * @param {number} number - The number to check against the maximum.
     * @returns {boolean} True if the number is greater than the maximum, otherwise false.
     */
    reachedMax(number) {
      return number > this.max;
    }

    /**
     * Determines if the given number has reached either the minimum or maximum limit.
     *
     * @param {number} number - The number to check against the limits.
     * @returns {boolean} True if the number has reached the minimum or maximum limit, otherwise false.
     */
    reachedAny(number) {
      return this.reachedMin(number) || this.reachedMax(number);
    }

    /**
     * Constrains the given number within the minimum and maximum bounds.
     * If the number has not reached any bound, it is returned as is.
     * If the number exceeds the bounds, returns the closest bound (min or max).
     *
     * @param {number} number - The number to constrain.
     * @returns {number} The constrained number within the min and max bounds.
     */
    constrain(number) {
      if (!this.reachedAny(number)) {
        return number;
      }

      return this.reachedMin(number) ? this.min : this.max;
    }

    /**
     * Adjusts the given number by removing the offset based on the length and max properties.
     * If the length is not defined or zero, returns the original number.
     * Otherwise, subtracts a multiple of length to bring the number within a certain range.
     *
     * @param {number} number - The number to adjust.
     * @returns {number} The adjusted number with the offset removed.
     */
    removeOffset(number) {
      if (!this.length) {
        return number;
      }

      return number - this.length * Math.ceil((number - this.max) / this.length);
    }
  }

  global.NewHomeSource.Carousel.Limit = Limit;
}(window));
